import React from 'react';
import { Icon } from 'ui';
import { withTooltip } from 'components/shared/Tooltip';

const PathContentControls = ({ reorder, connectDragSource }) => (
  <div className="EditorElement-controls PathContent-controls">
    {connectDragSource(
      <div className="EditorElement-controlButton PathContent-controlButton d-f ai-c jc-c">
        {withTooltip({ text: 'Move', hideOnMouseUp: true })(
          <Icon name="reorder" className="mt-0" />,
        )}
      </div>,
    )}
  </div>
);

export default PathContentControls;
